import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "Is SSK Enterprises an authorised distributor for MR Chemie NDT products?",
    a: "Yes. SSK Enterprises is the Authorised Distributor of 3AK Chemie Pvt. Ltd. — the exclusive India representative of MR Chemie GmbH, Germany — for MR Chemie NDT materials, equipment and accessories. You can view the current authorisation certificate on our Certificates page.",
  },
  {
    q: "Which regions do you supply NDT materials and industrial bearings in?",
    a: "We supply MR Chemie NDT materials, NDT inspection equipment, KLYDE zinc coatings and industrial bearings across Telangana and Andhra Pradesh. Our office is located in Kukatpally, Hyderabad, from where we serve customers across both states.",
  },
  {
    q: "What NDT products can you supply?",
    a: "Dye Penetrant Testing consumables (cleaners, red visible & fluorescent penetrants, developers), Magnetic Particle Inspection materials (magnetic inks, powders, contrast paints), UV inspection equipment (UV-A lamps, lux & UV intensity meters), reference test blocks and general NDT accessories — all from MR Chemie GmbH, Germany.",
  },
  {
    q: "What is included in your KLYDE zinc materials range?",
    a: "The KLYDE zinc materials range covers cold galvanizing sprays, zinc-rich primers, zinc paints, zinc metal coatings and industrial protective coatings — suitable for galvanizing plants, fabrication units, maintenance workshops and OEM builds needing long-term corrosion protection.",
  },
  {
    q: "Do you supply NTN bearings and other industrial bearings?",
    a: "Yes. We supply industrial bearings based on customer requirements, including NTN bearings and other leading brands where applicable. Share the bearing number, a photo of the existing bearing or the machine application, and our team will revert with availability and pricing.",
  },
  {
    q: "How do I request a quotation and what are your business hours?",
    a: "Use the Request a Quotation button on any page, WhatsApp us on +91 8309352443, call +91 8309352443 (office) or email sales@ssk21.net. We operate Monday through Saturday, 9:00 AM to 7:00 PM. Enquiries usually receive a response within one business day.",
  },
];

export default function FAQ() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  React.useEffect(() => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-seo-faq", "1");
    s.text = JSON.stringify(jsonLd);
    document.head.appendChild(s);
    return () => s.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="section section-alt" data-testid="faq-section">
      <div className="container-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="w-12 h-12 bg-[#0F2747] text-white flex items-center justify-center">
            <HelpCircle className="w-6 h-6" />
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-black text-[#1E293B] mt-6 leading-tight">Frequently asked questions</h2>
          <p className="text-slate-600 mt-4 leading-relaxed">
            Common questions from industrial buyers about our authorisation, product range, coverage area and quotation process.
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="bg-white border border-slate-200">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200 last:border-b-0" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-semibold text-[#1E293B] px-5 py-5 hover:no-underline hover:text-[#0F2747]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-5 pb-5 text-slate-600 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
